export default __webpack_public_path__ + "static/media/photo.83ba507f.jpg";